var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { FollowRequestStatus } from '@amityco/js-sdk';
import { ButtonsContainer, UserHeaderContainer } from '../../../../social/pages/UserFeed/Followers/styles';
import UserHeader from '../../../../social/components/UserHeader';
import useFollow from '../../../../core/hooks/useFollow';
import Button, { PrimaryButton } from '../../../../core/components/Button';
import withSDK from '../../../../core/hocs/withSDK';
import { notification } from '../../../../core/components/Notification';
import { useAsyncCallback } from '../../../../core/hooks/useAsyncCallback';
import useFollowersList from '../../../../core/hooks/useFollowersList';
import PaginatedList from '../../../../core/components/PaginatedList';
import { Grid } from '../../../../social/components/community/CategoryCommunitiesList/styles';
import Skeleton from '../../../../core/components/Skeleton';
import { useSDK } from '../../../../core/hooks/useSDK';
const PendingItem = ({ currentUserId, userId }) => {
    const { followAccept, deleteFollower } = useFollow(currentUserId, userId);
    const { connected } = useSDK();
    const [onFollowAccept] = useAsyncCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield followAccept();
        notification.success({ content: React.createElement(FormattedMessage, { id: "notification.done" }) });
    }), [followAccept]);
    const [onFollowDecline] = useAsyncCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield deleteFollower();
        notification.success({ content: React.createElement(FormattedMessage, { id: "notification.done" }) });
    }), [deleteFollower]);
    return (React.createElement(UserHeaderContainer, null,
        React.createElement(UserHeader, { userId: userId }),
        React.createElement(ButtonsContainer, null,
            React.createElement(PrimaryButton, { isFullWidth: true, disabled: !connected, onClick: onFollowAccept },
                React.createElement(FormattedMessage, { id: "request.accept" })),
            React.createElement(Button, { isFullWidth: true, disabled: !connected, onClick: onFollowDecline },
                React.createElement(FormattedMessage, { id: "request.decline" })))));
};
const PendingList = ({ currentUserId }) => {
    const [pendingUsers, hasMore, loadMore, loading, loadingMore] = useFollowersList(currentUserId, FollowRequestStatus.Pending);
    const items = useMemo(() => {
        function getLoadingItems() {
            return new Array(5).fill(1).map((x, index) => ({ userId: index, skeleton: true }));
        }
        if (loading) {
            return getLoadingItems();
        }
        if (!loadingMore) {
            return pendingUsers;
        }
        return [...pendingUsers, ...getLoadingItems()];
    }, [pendingUsers, loading, loadingMore]);
    return (React.createElement(PaginatedList, { items: items, hasMore: hasMore, loadMore: loadMore, container: Grid }, ({ skeleton, userId }) => skeleton ? (React.createElement(Skeleton, { count: 3, style: { fontSize: 8 } })) : (React.createElement(PendingItem, { key: userId, userId: userId, currentUserId: currentUserId }))));
};
export default withSDK(PendingList);
//# sourceMappingURL=PendingList.js.map